export default "__VITE_ASSET__BU1kEPXk__"